// i18n.js
import { createI18n } from 'vue-i18n'
import axios from 'axios'
import store from '@/store'

const { locale, translations } = window.config

// Create the i18n instance
export const i18n = createI18n({
  legacy: false, // ✅ Use Composition API mode
  globalInjection: true, // ✅ Makes $t available globally
  locale,
  messages: {
    [locale]: translations
  }
})

/**
 * Set a new locale dynamically
 * @param {String} locale
 */
export async function setLocale(locale) {
  await loadTranslations(locale)

  if (i18n.global.locale.value !== locale) {
    i18n.global.locale.value = locale
    store.dispatch('lang/setLocale', { locale })
    document.querySelector('html').setAttribute('lang', locale)
  }
}

/**
 * Load new translations only if not already present
 * @param {String} locale
 */
async function loadTranslations(locale) {
  if (Object.keys(i18n.global.getLocaleMessage(locale)).length === 0) {
    const { data } = await axios.get(`/api/translations/${locale}`)
    i18n.global.setLocaleMessage(locale, data)
  }
}
